import React, {FC} from 'react';
import {connect} from 'react-redux';

import {useToggle} from '../../../../../libs/shared/helpers/src/react/hooks/hookHelpers';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {TrialRestartedBanner} from './trialRestartedBanner';

/*
 * Props.
 */

interface TrialRestartedBannerContainerComponentProps {
  hasTrialRestarted: boolean;
}

/*
 * Selectors.
 */

function getHasTrialRestarted(state: AppState) {
  return state.data.config.hasTrialRestarted;
}

/*
 * Component.
 */

export const TrialRestartedBannerContainerComponent: FC<TrialRestartedBannerContainerComponentProps> = (
  props,
) => {
  const [shouldDisplayBanner, toggleShouldDisplayBanner] = useToggle(props.hasTrialRestarted);
  if (!shouldDisplayBanner) {
    return null;
  }

  return <TrialRestartedBanner onDismissClick={toggleShouldDisplayBanner} />;
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  hasTrialRestarted: getHasTrialRestarted,
}));

export const TrialRestartedBannerContainer = connect(mapStateToProps)(TrialRestartedBannerContainerComponent);
